// import { Add, Edit } from "@mui/icons-material";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { LoadingButton } from "@mui/lab";
// import {
//   Chip,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   Paper,
//   SwipeableDrawer,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
// } from "@mui/material";
// import jwtAuthAxios from "app/services/auth/jwtAuth";
// import React from "react";
// import { useState } from "react";
// import { useEffect } from "react";
// import { useFormik } from "formik";
// import * as yup from "yup";
// import TextField from "@mui/material/TextField";
// import Box from "@mui/material/Box";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
// import TableSkeleton from "app/shared/widgets/TableSkeleton";
// import useJumboAuth from "@jumbo/hooks/useJumboAuth";
// import Div from "@jumbo/shared/Div";
// const validationSchema = yup.object({
//   FL_STONE_ID: yup.string().required("STONE ID is required"),
//   PRICE: yup.string().required("PRICE is required"),
// });

// const ManualRapDialog = () => {
//   const [users, setUsers] = useState([]);
//   const [drawer, setDrawer] = useState(false);
//   const [isEdit, setIsEdit] = useState(false);
//   const [searchUserDialoge, setSearchUserDialoge] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const { rights } = useJumboAuth();
//   const swal = useSwalWrapper();

//   const formik = useFormik({
//     initialValues: {
//       FL_STONE_ID: "",
//       PRICE: "",
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       setLoading(true);
//       if (isEdit) {
//         let payloads = {
//           type: "U",
//           data: values,
//         };
//         await jwtAuthAxios
//           .post(`pricing/manualrap`, payloads)
//           .then((data) => {
//             if (data.data.status == "success") {
//               fetchManualRapData();
//               setDrawer(false);
//               swal.fire({
//                 icon: "success",
//                 text: data.data.message,
//               });
//             } else {
//               swal.fire({
//                 icon: "error",
//                 text: "something Went Wrong",
//               });
//             }
//             setLoading(false);
//           })
//           .catch(() => {
//             swal.fire({
//               icon: "error",
//               text: "Something went wrong",
//             });
//             setLoading(false);
//           });
//       } else {
//         let payload = {
//           type: "I",
//           data: [values],
//         };
//         await jwtAuthAxios
//           .post(`pricing/manualrap`, payload)
//           .then((data) => {
//             if (data.data.status == "success") {
//               fetchManualRapData();
//               setDrawer(false);
//               swal.fire({
//                 icon: "success",
//                 text: data.data.message,
//               });
//             } else {
//               swal.fire({
//                 icon: "error",
//                 text: "something Went Wrong",
//               });
//             }
//             setLoading(false);
//           })
//           .catch(() => {
//             swal.fire({
//               icon: "error",
//               text: "Something went wrong",
//             });
//             setLoading(false);
//           });
//       }
//     },
//   });

//   const fetchManualRapData = async (searchData) => {
//     try {
//       setUsers([]);
//       const { data } = await jwtAuthAxios.post("pricing/manualrap");
//       setUsers(data);
//     } catch (error) {
//       swal.fire({
//         icon: "error",
//         text: "Something went wrong",
//       });
//       // Handle errors here
//     }
//   };

//   useEffect(() => {
//     fetchManualRapData();
//   }, []);

//   useEffect(async () => {
//     if (drawer == false) {
//       formik.resetForm();
//     }
//   }, [drawer]);

//   const userEditHandler = (user) => {
//     formik.setFieldValue("FL_STONE_ID", user?.FL_STONE_ID);
//     formik.setFieldValue("PRICE", user?.PRICE);
//     setDrawer(true);
//     setIsEdit(true);
//   };

//   const userDeleteHandler = async (user) => {
//     let pay = {
//       type: "D",
//       data: user,
//     };

//     try {
//       setUsers([]);
//       const { data } = await jwtAuthAxios
//         .post("pricing/manualrap", pay)
//         .then((data) => {
//           if (data.data.status === "success") {
//             fetchManualRapData();
//             swal.fire({
//               icon: "success",
//               text: data.data.message,
//             });
//           } else {
//             swal.fire({
//               icon: "error",
//               text: "Something went wrong",
//             });
//           }
//         });
//     } catch (error) {
//       swal.fire({
//         icon: "error",
//         text: "Something went wrong",
//       });
//       // Handle errors here
//     }
//   };
//   return (
//     <div>
//       <Div
//         sx={{
//           display: "flex",
//           margin: "0 0px 22px auto",
//           justifyContent: "end",
//           gap: "15px",
//         }}
//       >
//         <LoadingButton
//           variant="contained"
//           onClick={() => setSearchUserDialoge(true)}
//           startIcon={<FilterAltIcon />}
//           color="primary"
//         >
//           Sync
//         </LoadingButton>
//         {rights?.insert == 1 && (
//           <LoadingButton
//             variant="contained"
//             onClick={() => {
//               setIsEdit(false);
//               setDrawer(true);
//             }}
//             startIcon={<Add />}
//             color="primary"
//           >
//             Add Manual Rap Dialog
//           </LoadingButton>
//         )}
//       </Div>
//       {users.length > 0 ? (
//         <TableContainer component={Paper}>
//           <Table size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell>STONE ID</TableCell>
//                 <TableCell>PRICE</TableCell>
//                 <TableCell align="right">Action</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {users.map((user, index) => {
//                 return (
//                   <TableRow key={index}>
//                     <TableCell>{user.FL_STONE_ID}</TableCell>
//                     <TableCell>{user.PRICE}</TableCell>
//                     <TableCell
//                       align="right"
//                       style={{
//                         gap: "10px",
//                         display: "flex",
//                         flexDirection: "row",
//                         justifyContent: "end",
//                       }}
//                     >
//                       {rights?.edit == 1 && (
//                         <Chip
//                           color={"success"}
//                           onClick={() => userEditHandler(user)}
//                           icon={<Edit fontSize="18px" />}
//                           label="edit"
//                         />
//                       )}
//                       {rights?.delete == 1 && (
//                         <Chip
//                           color={"error"}
//                           onClick={() => userDeleteHandler(user)}
//                           icon={<DeleteIcon fontSize="18px" />}
//                           label="delete"
//                         />
//                       )}
//                     </TableCell>
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       ) : (
//         <TableSkeleton cols={7} />
//       )}
//       <SwipeableDrawer
//         anchor="right"
//         open={drawer}
//         onClose={() => setDrawer(false)}
//         onOpen={() => setDrawer(true)}
//       >
//         <Box
//           component="form"
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             minWidth: "500px",
//             margin: "0 auto",
//             p: 3,
//           }}
//           onSubmit={formik.handleSubmit}
//         >
//           <h3 style={{ padding: "5px", marginTop: "0" }}>Manage Rap Dialog</h3>
//           <TextField
//             label="STONE ID"
//             variant="outlined"
//             sx={{ mb: 0 }}
//             margin="normal"
//             size="small"
//             fullWidth
//             autoFocus
//             {...formik.getFieldProps("FL_STONE_ID")}
//             error={
//               formik.touched.FL_STONE_ID && Boolean(formik.errors.FL_STONE_ID)
//             }
//             helperText={formik.touched.FL_STONE_ID && formik.errors.FL_STONE_ID}
//           />
//             <TextField
//               label="PRICE"
//               variant="outlined"
//               margin="normal"
//               size="small"
//               sx={{ mb: 0 }}
//               fullWidth
//               {...formik.getFieldProps("PRICE")}
//               error={formik.touched.PRICE && Boolean(formik.errors.PRICE)}
//               helperText={formik.touched.PRICE && formik.errors.PRICE}
//             />
//           <LoadingButton
//             loading={loading}
//             type="submit"
//             variant="contained"
//             color="primary"
//             sx={{ marginTop: "16px" }}
//           >
//             Submit
//           </LoadingButton>
//         </Box>
//       </SwipeableDrawer>
//       <MyUserFilterDialogForm
//         open={searchUserDialoge}
//         setOpen={setSearchUserDialoge}
//         callback={fetchManualRapData}
//       />
//     </div>
//   );
// };
// const MyUserFilterDialogForm = ({ open, setOpen, callback }) => {
//   const [searchData, setSearchData] = useState();
//   const [ParamsData, setParamsData] = useState([]);
//   const [stoneId, setStoneId] = useState("");
//   const [price, setPrice] = useState("");
//   const { rights } = useJumboAuth();
//   const swal = useSwalWrapper();

//   const handleClose = () => {
//     callback(searchData);
//     setOpen(false);
//   };

//   const handleStoneIdChange = (event) => {
//     setStoneId(event.target.value);
//   };

//   const handlePriceChange = (event) => {
//     setPrice(event.target.value);
//   };

//   const fetchManualRapSyncData = async (searchData) => {
//     try {
//       const { data } = await jwtAuthAxios.post("pricing/manualrap", {
//         type: "A",
//       });
//       setSearchData(data);
//     } catch (error) {
//       swal.fire({
//         icon: "error",
//         text: "something Went Wrong",
//       });
//       // Handle errors here
//     }
//   };

//   useEffect(() => {
//     if (open) {
//       fetchManualRapSyncData();
//     }
//   }, [open]);

//   const formEditSubmitHandler = async (row) => {
//     let payload = {
//       type: "I",
//       data: row?.filter((i) => i?.PRICE),
//     };
//     await jwtAuthAxios
//       .post(`pricing/manualrap`, payload)
//       .then((data) => {
//         if (data.data.status == "success") {
//           fetchManualRapSyncData();
//           handleClose();
//           swal.fire({
//             icon: "success",
//             text: data.data.message,
//           });
//         } else {
//           swal.fire({
//             icon: "error",
//             text: "something Went Wrong",
//           });
//         }
//       })
//       .catch((error) => {
//         swal.fire({
//           icon: "error",
//           text: "something Went Wrong",
//         });
//       });
//   };

//   const handleBlur = (e, index) => {
//     const newData = [...searchData];
//     newData[index].PRICE = e.target.value;
//     setSearchData(newData);
//   };

//   const defaultParamsData = [{ FL_STONE_ID: "", PRICE: "" }];
//   const data = ParamsData?.length ? ParamsData : defaultParamsData;
//   return (
//     <div>
//       <Dialog open={open} onClose={handleClose}>
//         <DialogTitle>Sync</DialogTitle>
//         <DialogContent>
//           <Table size="small" aria-label="purchases">
//             <TableHead>
//               <TableRow>
//                 <TableCell>ID</TableCell>
//                 <TableCell align="center">STONE ID</TableCell>
//                 <TableCell align="center">PRICE</TableCell>
//                 <TableCell align="center">Action</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {searchData?.map((selectedParamType, index) => (
//                 <TableRow key={index}>
//                   <TableCell component="th" scope="row">
//                     <Div>{index + 1}</Div>
//                   </TableCell>
//                   <TableCell>
//                     <TextField
//                       size="small"
//                       fullWidth
//                       id={`detail-${selectedParamType.FL_STONE_ID}-a`}
//                       defaultValue={selectedParamType.FL_STONE_ID}
//                     />
//                   </TableCell>
//                   <TableCell align="right">
//                     <TextField
//                       size="small"
//                       fullWidth
//                       id={`detail-${selectedParamType.FL_STONE_ID}-b`}
//                       onBlur={(e) => {
//                         handleBlur(e, index);
//                       }}
//                       defaultValue={selectedParamType.PRICE}
//                     />
//                   </TableCell>
//                   <TableCell align="right">
//                     <div
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         alignItems: "center",
//                       }}
//                     >
//                       {rights?.edit == 1 && (
//                         <LoadingButton
//                           variant="contained"
//                           size="small"
//                           onClick={() => {
//                             formEditSubmitHandler(searchData);
//                           }}
//                           color="primary"
//                         >
//                           Save
//                         </LoadingButton>
//                       )}
//                       {rights?.delete == 1 && (
//                         <LoadingButton
//                           variant="contained"
//                           size="small"
//                           onClick={() => {
//                             try {
//                               let pay = {
//                                 type: "D",
//                                 data: {
//                                   FL_STONE_ID: selectedParamType?.FL_STONE_ID,
//                                 },
//                               };
//                               jwtAuthAxios
//                                 .post("pricing/manualrap", pay)
//                                 .then(() => {
//                                   setOpen(!open);
//                                 });
//                             } catch (error) {
//                               swal.fire({
//                                 icon: "error",
//                                 text: "something Went Wrong",
//                               });
//                             }
//                           }}
//                           color="error"
//                         >
//                           Delete
//                         </LoadingButton>
//                       )}
//                     </div>
//                   </TableCell>
//                 </TableRow>
//               ))}
//               {rights.insert == 1 && (
//                 <TableRow>
//                   <TableCell component="th" scope="row">
//                     <Div>-</Div>
//                   </TableCell>
//                   <TableCell>
//                     <TextField
//                       size="small"
//                       fullWidth
//                       id={`detail-${data[0]?.FL_STONE_ID}-a`}
//                       value={stoneId}
//                       onChange={handleStoneIdChange}
//                     />
//                   </TableCell>
//                   <TableCell align="right">
//                     <TextField
//                       size="small"
//                       fullWidth
//                       id={`detail-${data[0]?.PRICE}-b`}
//                       value={price}
//                       onChange={handlePriceChange}
//                     />
//                   </TableCell>
//                   <TableCell align="right">
//                     <div
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         alignItems: "center",
//                       }}
//                     >
//                       {rights.edit == 1 && (
//                         <LoadingButton
//                           variant="contained"
//                           size="small"
//                           //sx={{ mr: 5 }}
//                           onClick={() => {
//                             formEditSubmitHandler([
//                               {
//                                 FL_STONE_ID: stoneId,
//                                 PRICE: price,
//                                 FL_SYNOID: null,
//                               },
//                             ]);
//                           }}
//                           color="primary"
//                         >
//                           Save
//                         </LoadingButton>
//                       )}
//                       {rights.delete == 1 && (
//                         <LoadingButton
//                           variant="contained"
//                           size="small"
//                           // sx={{ mr: 5 }}
//                           color="error"
//                           onClick={() => {
//                             try {
//                               let pay = {
//                                 type: "D",
//                                 data: {
//                                   FL_STONE_ID: stoneId,
//                                 },
//                               };
//                               jwtAuthAxios
//                                 .post("pricing/manualrap", pay)
//                                 .then(() => {
//                                   setOpen(!open);
//                                 });
//                             } catch (error) {
//                               swal.fire({
//                                 icon: "error",
//                                 text: "something Went Wrong",
//                               });
//                             }
//                           }}
//                         >
//                           Delete
//                         </LoadingButton>
//                       )}
//                     </div>
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         </DialogContent>
//       </Dialog>
//     </div>
//   );
// };

// export default ManualRapDialog;



import { Add, Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { LoadingButton } from "@mui/lab";
import {
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Box,
} from "@mui/material";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import TableSkeleton from "app/shared/widgets/TableSkeleton";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import Div from "@jumbo/shared/Div";

const ManualRapDialog = () => {
  const [users, setUsers] = useState([]);
  const [drawer, setDrawer] = useState(false);
  const [stoneCert, setStoneCert] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [searchUserDialoge, setSearchUserDialoge] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resultView, setResultView] = useState([]);
  const [updatedResults, setUpdatedResults] = useState([]);
  const { rights } = useJumboAuth();
  const swal = useSwalWrapper();

  const fetchManualRapData = async () => {
    try {
      
      const { data } = await jwtAuthAxios.post("pricing/manualrap");
      setUsers(data);

    } catch (e) {
      swal.fire({
        icon: "error",
        text: "Something went wrong",
      });
    }
  };

  useEffect(() => {
    fetchManualRapData();
  }, []);

  const stoneSearchHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = { stoneCert };
    try {
      const res = await jwtAuthAxios.post("search/stone", payload);
      setResultView(res.data.result || []);
      setUpdatedResults(res.data.result.map((item) => ({
        ...item,
        RAP_PRICE: item.RAP_PRICE || "",
      })));
    } catch (e) {
      swal.fire({
        icon: "error",
        text: "Internal server error",
      });
    }
    setLoading(false);
  };

  const handlePriceChange = (index, value) => {
    setUpdatedResults((prevResults) => {
      const newResults = [...prevResults];
      newResults[index].RAP_PRICE = value;
      return newResults;
    });
  };

  const submitUpdatedData = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {     
      const payload = {
        type: isEdit ? "U" : "I", 
        data: updatedResults.map(sd => ({
          FL_STONE_ID: sd['STONE'],
          PRICE: sd['RAP_PRICE']
        })),
      };
      const { data } = await jwtAuthAxios.post("pricing/manualrap", payload);
      if (data.status === "success") {
        setDrawer(false);
        fetchManualRapData();
        swal.fire({
          icon: "success",
          text: data.message,
        })
       
      } else {
        swal.fire({
          icon: "error",
          text: "Something went wrong",
        });
      }
    } catch (error) {
      swal.fire({
        icon: "error",
        text: "Something went wrong",
      });
    } finally {
      setLoading(false);
   
    }
  };
  

  const userDeleteHandler = async (user) => {
    let pay = {
      type: "D",
      data: user,
    };

    try {
      const { data } = await jwtAuthAxios.post("pricing/manualrap", pay);
      if (data.status === "success") {
        fetchManualRapData();
        swal.fire({
          icon: "success",
          text: data.message,
        })
      } else {
        swal.fire({
          icon: "error",
          text: "Something went wrong",
        });
      }
    } catch (error) {
      swal.fire({
        icon: "error",
        text: "Something went wrong",
      });
    } finally {
      setLoading(false);

    }
  };

  return (
    <div>
      <Div
        sx={{
          display: "flex",
          margin: "0 0px 22px auto",
          justifyContent: "end",
          gap: "15px",
        }}
      >
        <LoadingButton
          variant="contained"
          onClick={() => setSearchUserDialoge(true)}
          startIcon={<FilterAltIcon />}
          color="primary"
        >
          Sync
        </LoadingButton>
        {rights?.insert === 1 && (
          <LoadingButton
            variant="contained"
            onClick={() => {
              setIsEdit(false);
              setDrawer(true);
            }}
            startIcon={<Add />}
            color="primary"
          >
            Add Manual Rap Dialog
          </LoadingButton>
        )}
      </Div>
      {users.length > 0 ? (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>STONE ID</TableCell>
                <TableCell>PRICE</TableCell>
                <TableCell align="right">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user, index) => (
                <TableRow key={index}>
                  <TableCell>{user.FL_STONE_ID}</TableCell>
                  <TableCell>{user.PRICE}</TableCell>
                  <TableCell
                    align="right"
                    style={{
                      gap: "10px",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "end",
                    }}
                  >
                    {rights?.edit === 1 && (
                    
                      <Chip
                        color={"success"}
                        
                        onClick={() => {
                          setIsEdit(true);
                          setStoneCert(user.FL_STONE_ID);
                          setDrawer(true);
                        }}
                        icon={<Edit fontSize="18px" />}
                        label="edit"
                      />
                    )}
                    {rights?.delete === 1 && (
                      <Chip
                        color={"error"}
                        onClick={() => userDeleteHandler(user)}
                        icon={<DeleteIcon fontSize="18px" />}
                        label="delete"
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableSkeleton cols={7} />
      )}
      <Dialog open={drawer} onClose={() => setDrawer(false)}>
        <DialogContent>
          <form onSubmit={stoneSearchHandler}>
            <Box display="flex" alignItems="center" mb={2}>
              <TextField
                label="Stone ID"
                name="stoneId"
                value={stoneCert}
                onChange={(e) => setStoneCert(e.target.value)}
                fullWidth
              />
              <LoadingButton
                type="submit"
                variant="contained"
                color="primary"
                loading={loading}
                startIcon={<FilterAltIcon />}
                sx={{ ml: 2 }}
              >
                {isEdit ? 'Update Price' : 'Search'}
              </LoadingButton>
            </Box>
          </form>
          {loading ? (
            <TableSkeleton />
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Stone ID</TableCell>
                    <TableCell>Shape</TableCell>
                    <TableCell>Color</TableCell>
                    <TableCell>Clarity</TableCell>
                    <TableCell>Carat</TableCell>
                    <TableCell>Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {resultView.length > 0 ? (
                    updatedResults.map((item, index) => (
                      <TableRow key={item.STONE}>
                        <TableCell>{item.STONE}</TableCell>
                        <TableCell>{item.SHAPE}</TableCell>
                        <TableCell>{item.COLOR}</TableCell>
                        <TableCell>{item.CLARITY}</TableCell>
                        <TableCell>{item.CARATS}</TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            value={item.RAP_PRICE || ""}
                            onChange={(e) => handlePriceChange(index, e.target.value)}
                            fullWidth
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6}>No Results Found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <Box mt={2}>
            <LoadingButton
              type="submit"
              variant="contained"
              color="primary"
              onClick={submitUpdatedData}
              loading={loading}
            >
              {isEdit ? 'Update' : 'Save'}
            </LoadingButton>
          </Box>
        </DialogContent>
      </Dialog>
      <MyUserFilterDialogForm
        open={searchUserDialoge}
        setOpen={setSearchUserDialoge}
        callback={fetchManualRapData}
      />
    </div>
  );
};
const MyUserFilterDialogForm = ({ open, setOpen, callback }) => {
  const [searchData, setSearchData] = useState();
  const [ParamsData, setParamsData] = useState([]);
  const [stoneId, setStoneId] = useState("");
  const [price, setPrice] = useState("");
  const { rights } = useJumboAuth();
  const swal = useSwalWrapper();

  const handleClose = () => {
    callback(searchData);
    setOpen(false);
  };

  const handleStoneIdChange = (event) => {
    setStoneId(event.target.value);
  };

  const handlePriceChange = (event) => {
    setPrice(event.target.value);
  };

  const fetchManualRapSyncData = async (searchData) => {
    try {
      const { data } = await jwtAuthAxios.post("pricing/manualrap", {
        type: "A",
      });
      setSearchData(data);
    } catch (error) {
      swal.fire({
        icon: "error",
        text: "something Went Wrong",
      });
      // Handle errors here
    }
  };

  useEffect(() => {
    if (open) {
      fetchManualRapSyncData();
    }
  }, [open]);

  const formEditSubmitHandler = async (row) => {
    let payload = {
      type: "I",
      data: row?.filter((i) => i?.PRICE),
    };
    await jwtAuthAxios
      .post(`pricing/manualrap`, payload)
      .then((data) => {
        if (data.data.status == "success") {
          fetchManualRapSyncData();
          handleClose();
          swal.fire({
            icon: "success",
            text: data.data.message,
          });
        } else {
          swal.fire({
            icon: "error",
            text: "something Went Wrong",
          });
        }
      })
      .catch((error) => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
  };

  const handleBlur = (e, index) => {
    const newData = [...searchData];
    newData[index].PRICE = e.target.value;
    setSearchData(newData);
  };

  const defaultParamsData = [{ FL_STONE_ID: "", PRICE: "" }];
  const data = ParamsData?.length ? ParamsData : defaultParamsData;
  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Sync</DialogTitle>
        <DialogContent>
          <Table size="small" aria-label="purchases">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell align="center">STONE ID</TableCell>
                <TableCell align="center">PRICE</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {searchData?.map((selectedParamType, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    <Div>{index + 1}</Div>
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      fullWidth
                      id={`detail-${selectedParamType.FL_STONE_ID}-a`}
                      defaultValue={selectedParamType.FL_STONE_ID}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <TextField
                      size="small"
                      fullWidth
                      id={`detail-${selectedParamType.FL_STONE_ID}-b`}
                      onBlur={(e) => {
                        handleBlur(e, index);
                      }}
                      defaultValue={selectedParamType.PRICE}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      {rights?.edit == 1 && (
                        <LoadingButton
                          variant="contained"
                          size="small"
                          onClick={() => {
                            formEditSubmitHandler(searchData);
                          }}
                          color="primary"
                        >
                          Save
                        </LoadingButton>
                      )}
                      {rights?.delete == 1 && (
                        <LoadingButton
                          variant="contained"
                          size="small"
                          onClick={() => {
                            try {
                              let pay = {
                                type: "D",
                                data: {
                                  FL_STONE_ID: selectedParamType?.FL_STONE_ID,
                                },
                              };
                              jwtAuthAxios
                                .post("pricing/manualrap", pay)
                                .then(() => {
                                  setOpen(!open);
                                });
                            } catch (error) {
                              swal.fire({
                                icon: "error",
                                text: "something Went Wrong",
                              });
                            }
                          }}
                          color="error"
                        >
                          Delete
                        </LoadingButton>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
              {rights.insert == 1 && (
                <TableRow>
                  <TableCell component="th" scope="row">
                    <Div>-</Div>
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      fullWidth
                      id={`detail-${data[0]?.FL_STONE_ID}-a`}
                      value={stoneId}
                      onChange={handleStoneIdChange}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <TextField
                      size="small"
                      fullWidth
                      id={`detail-${data[0]?.PRICE}-b`}
                      value={price}
                      onChange={handlePriceChange}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      {rights.edit == 1 && (
                        <LoadingButton
                          variant="contained"
                          size="small"
                          //sx={{ mr: 5 }}
                          onClick={() => {
                            formEditSubmitHandler([
                              {
                                FL_STONE_ID: stoneId,
                                PRICE: price,
                                FL_SYNOID: null,
                              },
                            ]);
                          }}
                          color="primary"
                        >
                          Save
                        </LoadingButton>
                      )}
                      {rights.delete == 1 && (
                        <LoadingButton
                          variant="contained"
                          size="small"
                          // sx={{ mr: 5 }}
                          color="error"
                          onClick={() => {
                            try {
                              let pay = {
                                type: "D",
                                data: {
                                  FL_STONE_ID: stoneId,
                                },
                              };
                              jwtAuthAxios
                                .post("pricing/manualrap", pay)
                                .then(() => {
                                  setOpen(!open);
                                });
                            } catch (error) {
                              swal.fire({
                                icon: "error",
                                text: "something Went Wrong",
                              });
                            }
                          }}
                        >
                          Delete
                        </LoadingButton>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
    </div>
  );
};


export default ManualRapDialog;
